import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

//ANT DESIGN IMPORTS
import { Input, Row, Card, Form, Col, Divider, Spin } from "antd";

//PROJECT IMPORTS
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";
import MainLayout from "../../../components/layouts/MainLayout";
import TopContent from "../../../components/layouts/TopContent";
import { apiConfig, labelConfig, staticConfig } from "../configurations.config";
import CustomButton from "../../../components/custom/CustomButton";

const EditCode = (props) => {
  const { userData } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const [useForm] = Form.useForm();
  const { state } = useLocation();
  const [codeDetail, setCodeDetail] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getDetalById();
  }, []);

  function getDetalById() {
    const url = `${apiConfig.Codes}/${state.id}`;
    let body = {
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        const objList = res;

        useForm.setFieldsValue({
          name: objList?.name,
        });

        setCodeDetail();
      }
    });
    setIsLoading(false);
  }

  function onCancel() {
    navigate("/manage-codes");
  }

  const onSubmit = (formValues) => {
    const url = `${apiConfig.Codes}/${state.id}`;

    const body = {
      ...formValues,
      method: "PUT",
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
        setIsLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, labelConfig.editCodeMsg);
        navigate("/manage-codes");
        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  return (
    <MainLayout isEnableRightSidebar={true}>
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent
        pageTitle={labelConfig.editCode}
        pageItems={staticConfig.editCodeBreadcrumbItems}
      />

      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form form={useForm} layout="vertical" onFinish={onSubmit}>
            <Row>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.codeName}
                  name="name"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.codeName),
                    },
                  ]}
                >
                  <Input
                    placeholder={BOM.handlePlaceholderMsg(labelConfig.codeName)}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Divider />
              {BOM.HasPermission("UPDATE_CODE") && (
                <CustomButton
                  content="Submit"
                  style={{
                    width: "10%",
                    marginLeft: "auto",
                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                  }}
                  htmlType="submit"
                  backgroundColor="#92428B"
                  colorText="white"
                  hoverBackground="#AD4EA7"
                />
              )}

              <CustomButton
                content="Cancel"
                style={{
                  width: "10%",
                  marginLeft: "1%",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                backgroundColor="#fff"
                colorText="black"
                hoverBackground="#F5F5F5"
                onClick={onCancel}
              />
            </Row>
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};

export default EditCode;
